import {inject, Injectable, Signal, signal, WritableSignal} from '@angular/core';
import {HttpClient, httpResource} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {SubCities} from "../core/sub.cities";
import {ModalController} from "@ionic/angular/standalone";
import {EnquireModalComponent} from "./enquire-modal/enquire-modal.component";
import {CurrencyConvertService} from '../core/currency.convert.service';
import {Property} from './property-interface';

@Injectable({
  providedIn: 'root'
})
export class PropertyService {

  http: HttpClient = inject(HttpClient);
  subCategories: WritableSignal<any> = signal([]);
  filterValues: WritableSignal<any> = signal({
    minFloorArea: 0,
    maxFloorArea: 0,
    minPrice: 0,
    maxPrice: 0,
    minAge: 0,
    maxAge: 0
  });
  filterValuesInitial: WritableSignal<any> = signal({
    minFloorArea: 0,
    maxFloorArea: 0,
    minPrice: 0,
    maxPrice: 0,
    minAge: 0,
    maxAge: 0
  });
  selectedCategory: WritableSignal<any> = signal(null);
  cities: string[]  = [ "Riyadh", "Jeddah", "Mecca", "Medina", "Dammam", "Khobar",
    "Dhahran", "Jubail", "Tabuk", "Yanbu", "Hail", "Abha", "Khamis Mushait", "Najran", "Al Hofuf", "Al Qatif", "Taif", "Al Khafji",
    "Al Baha", "Al Qurayyat", "Sakakah", "Al Jouf", "Jazan", "Arar", "Al Bahah" ]
  subCities = SubCities.cityNames;
  modalController: ModalController = inject(ModalController);
  currencyConvertService: CurrencyConvertService = inject(CurrencyConvertService);
  constructor() {
    this.getSubCities();}

  async initializeData() {
    await this.getPropertyFilter();
    await this.getSubCategories();
  }
  async openEnquireModal(property: any) {
    console.clear();
    console.log(property);
    const modal = await this.modalController
      .create({
        component: EnquireModalComponent,
        backdropDismiss: false,
        componentProps: {property: property},
        cssClass: 'enquire-modal'
      });
    await modal.present();
  }
  getSubCities() {
    return new Promise<any>(() => {
      this.http.get<any>(`${environment.apiUrl}/address/cities/en`)
        .subscribe({
          next: data => {
            this.subCities = data;
          },
          error: data => console.log(data),
        })
    })
  }
  getSubCategories() {
    return new Promise<any>(resolve => {
      this.http.get<any>(`${environment.apiUrl}/categories/all`)
        .subscribe({
          next: data => {
            this.subCategories.set(data[0].subcategories);
            resolve(this.subCategories());
          },
          error: data => console.log(data),
        })
    })
  }
  getPropertyResource(propertyId: Signal<string>) {
    return httpResource<Property>(() =>
      propertyId() ? `${environment.apiUrl}/property/p/${propertyId()}?version=2` : undefined);
  }
  getMeta(propertyId: Signal<string>) {
    return httpResource<Property>(() =>
      propertyId() ? `${environment.apiUrl}/property/p/meta/${propertyId()}?version=2` : undefined);
  }
  getProperty(id: string) {
    return new Promise<any>((resolve, reject) => {
      this.http.get<any>(`${environment.apiUrl}/property/p/${id}`)
        .subscribe({
          next: data => resolve(data[0]),
          error: data => reject(data),
        })
    })
  }
  getPropertyFilter() {
    return new Promise<any>(resolve => {
      this.http.get<any>(`${environment.apiUrl}/property/filter/values`)
        .subscribe({
          next: data => {
            const filterData = data && data[0] && typeof data[0] === 'object' ? data[0] : {};
            this.filterValues.set(filterData);
            this.filterValuesInitial.set(filterData);
            resolve(this.filterValues());
          },
          error: data => {
            console.log(data);
            this.filterValues.set({});
            this.filterValuesInitial.set({});
            resolve({});
          },
        })
    })
  }

  getPropertyImages(id: string) {
    return new Promise<any>(resolve => {
      this.http.get<any>(`${environment.apiUrl}/images/property/${id}`)
        .subscribe({
          next: data => {
            resolve(data);
          },
          error: data => console.log(data),
        })
    })
  }
  getPropertyInfo(id: string) {
    return new Promise<any>(resolve => {
      this.http.get<any>(`${environment.apiUrl}/property/info/${id}`)
        .subscribe({
          next: data => {
            resolve(data);
          },
          error: data => console.log(data),
        })
    })
  }

  objectToQueryParams(obj: any) {
    if (!obj) {
      return {};
    }
    return Object.keys(obj)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
      .join('&');
  }
  isSearching: boolean = false;
  getProperties(query?: any) {
    this.isSearching = true;
    return new Promise<any>(async (resolve) => {
      if (query && query.subCatId) {
        const sub = this.subCategories().filter((item: any) => item._id === query.subCatId);
        this.selectedCategory.set(sub[0]);
      } else {
        this.selectedCategory.set(null);
      }
      if (query && query.maxPrice && query.minPrice) {
        const rate: any = await this.currencyConvertService.getExchangeRateFromCurrency(this.currencyConvertService.localCurrency());
        console.log(rate);
        query.minPrice = Number(query.minPrice) * rate;
        query.maxPrice = Number(query.maxPrice) * rate;
      }
      this.http.get<any>(`${environment.apiUrl}/property/filter?${this.objectToQueryParams(query ? query : {})}`)
        .subscribe({
          next: data => {
            this.isSearching = false;
            resolve(data);
          },
          error: data => {
            this.isSearching = false;
            console.log(data)
          },
        });
    })
  }
  getPropertyPins(query?: any) {
    return new Promise<any>(resolve => {
      if (query && query.subCatId) {
        const sub = this.subCategories().filter((item: any) => item._id === query.subCatId);
        this.selectedCategory.set(sub[0]);
      } else {
        this.selectedCategory.set(null);
      }
      this.http.get<any>(`${environment.apiUrl}/property/pins?${this.objectToQueryParams(query ? query : {})}`)
        .subscribe({
          next: data => resolve(data),
          error: data => console.log(data),
        })
    })
  }
}
